import React,{useState, useEffect} from 'react';
import { View, Text, StyleSheet } from 'react-native';
import CommonPage from '../components/CommonPage';
import ChatView from '../components/ChatView';
import AsyncStorage from '@react-native-async-storage/async-storage';

const AiChat = () => {
  const [userBalance,setUserBalance] = useState(null);
  const [balfetching,setbalanceFetching]=useState(false);

  const getUserBalance = async () => {
    setbalanceFetching(true)
    const userData = await AsyncStorage.getItem('user');
    if (userData) {
      const parsedData = JSON.parse(userData);
      setUserBalance(parsedData?.userBalance);
      setbalanceFetching(false)
    }
  };

  const setBalance = async (balance) => {
    try {
      setbalanceFetching(true);
      const userDataString = await AsyncStorage.getItem('user');
      if (userDataString) {
        const userData = JSON.parse(userDataString);
        userData.userBalance = balance; 
        await AsyncStorage.setItem('user', JSON.stringify(userData));
        setUserBalance(balance);
      }
    } catch (error) {
      console.error('Error setting balance:', error);
    } finally {
      setbalanceFetching(false); 
    }
  };

  useEffect(() => {
    getUserBalance();
  }, []);


  return (
    <View style={styles.container}>
      <CommonPage userBalance={userBalance} balfetching={balfetching}>
        <View style={styles.chatViewContainer}>
        <ChatView userBalance={userBalance} setUserBalance={(balance)=>setBalance(balance)} setbalanceFetching={setbalanceFetching}/>
        </View>
      </CommonPage>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  chatViewContainer:{
    flex: 1,
  }
});

export default AiChat;
